import { useParams } from 'react-router-dom';
import { SaveOfficeComponent } from './save-office.component';
import { SiTrackPage } from '../../../components/si-track-page';
import { useLoadData } from '../../../hooks/useLoadData';
import { ApiResponse } from '../../../models/api-response';
import { Office } from '../../../models/office';
import { officeApiKeyStore } from '../../../api/office-api-key-store';

export const EditOfficePage = () => {
  const { officeID } = useParams();
  const { isLoading, data } = useLoadData<ApiResponse<Office>>(officeApiKeyStore.getOffice(officeID));

  return (
    <SiTrackPage title="Edit Office" isLoading={isLoading}>
      {data && <SaveOfficeComponent customerID={data.data.customerID} office={{ ...data.data }} page="edit" />}
    </SiTrackPage>
  );
};
